(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3538],{

/***/ 7955:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...path]]",
      function () {
        return __webpack_require__(9128);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Path; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(2050);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/main.js
var main = __webpack_require__(128);
;// CONCATENATED MODULE: ./src/hooks/useHashScroll.ts


function useHashScroll(disabled) {
    var hash = (0,react.useSyncExternalStore)(subscribeToHashChange, getWindowHashSnapshot, function() {
        return undefined;
    });
    (0,main/* useInterval */.Yz)(function() {
        if (hash) {
            var element = document.getElementById(hash);
            if (element) {
                window.scrollTo(0, element.offsetTop);
                return true;
            }
        }
    }, 100, {
        maxDuration: 2000,
        disabled: disabled || !hash,
        executeImmediately: true
    });
}
function subscribeToHashChange(listener) {
    listener();
    window.addEventListener("hashchange", listener);
    return function() {
        return window.removeEventListener("hashchange", listener);
    };
}
function getWindowHashSnapshot() {
    return window.location.hash.slice(1);
}

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/util/magnolia.ts + 1 modules
var magnolia = __webpack_require__(7581);
;// CONCATENATED MODULE: ./src/hooks/usePageRedirect.ts



function usePageRedirect(redirectPage, redirectAnchorTag) {
    var ref = (0,router.useRouter)(), replace = ref.replace, isPreview = ref.isPreview;
    (0,react.useEffect)(function() {
        // Handle GNF: Redirect template
        if (redirectPage && !__webpack_require__.g.mgnlInPageEditor) {
            var redirectPath = (0,magnolia/* formatPageLink */.Jd)(redirectPage, false, redirectAnchorTag);
            replace(redirectPath);
        }
    }, [
        replace,
        redirectPage,
        redirectAnchorTag,
        isPreview
    ]);
}

// EXTERNAL MODULE: ./src/magnolia.config.ts
var magnolia_config = __webpack_require__(9937);
;// CONCATENATED MODULE: ./src/pages/[[...path]].tsx








var EditablePage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1341), __webpack_require__.e(5150)]).then(__webpack_require__.bind(__webpack_require__, 5150));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5150)
            ];
        }
    }
});
var __N_SSG = true;
function Path(props) {
    var page = props.page, templateAnnotations = props.templateAnnotations, isPreview = props.isPreview;
    var ref;
    var redirectPage = (ref = page === null || page === void 0 ? void 0 : page.redirectPage) !== null && ref !== void 0 ? ref : null;
    var ref1;
    var redirectAnchorTag = (ref1 = page === null || page === void 0 ? void 0 : page.redirectAnchorTag) !== null && ref1 !== void 0 ? ref1 : null;
    usePageRedirect(redirectPage, redirectAnchorTag);
    useHashScroll(!!redirectPage);
    if (!page) {
        return null;
    }
    if (isPreview) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EditablePage, {
            content: page,
            config: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, magnolia_config/* magnoliaEditablePageConfig */.iL), {
                componentMappings: Object.entries(magnolia_config/* magnoliaEditablePageConfig.componentMappings */.iL.componentMappings).reduce(function(acc, param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], Component = _param[1];
                    acc[key] = function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({
                            isPreview: isPreview
                        }, props));
                    };
                    return acc;
                }, {})
            }),
            templateAnnotations: templateAnnotations
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomPageRenderer, (0,_object_spread/* default */.Z)({}, page));
}
function CustomPageRenderer(page) {
    var PageComponent = (0,magnolia_config/* getComponentForMagnoliaTemplate */.rX)(page["mgnl:template"]);
    if (!PageComponent) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageComponent, (0,_object_spread/* default */.Z)({}, page), page["@id"]);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(7955); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);